import React from 'react';

export default function HistoryPanel({ history }) {
  return (
    <div className="w-1/5 bg-gray-100 h-screen overflow-y-auto border-l border-gray-300">
      <h2 className="p-4 text-lg font-semibold text-[#fdb814]">Request History</h2>
      {history.length === 0 ? (
        <p className="px-4 text-gray-600">No requests yet.</p>
      ) : (
        <ul>
          {history.map((entry, index) => (
            <li key={index} className="px-4 py-2 border-b border-gray-200">
              <div className="flex justify-between">
                <span className="font-semibold text-[#fdb814]">{entry.method}</span>
                <span className="text-sm text-gray-500">{new Date(entry.timestamp).toLocaleTimeString()}</span>
              </div>
              <p className="text-sm text-gray-800">{entry.url}</p>
              <p className="text-sm text-gray-600">Status: {entry.status || 'N/A'}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}